<h4>Trouble reports for test result</h4>
<div>
	<table mat-table [dataSource]="dataSource" matSort>
		<!-- ECU Column -->
		<ng-container matColumnDef="jiraIssue">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Jira issue</th>
			<td mat-cell *matCellDef="let element">
				<a href="{{ element.uri }}" target="_blank">{{ element.uri }}</a>
			</td>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="validFrom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Valid from</th>
			<td mat-cell *matCellDef="let element">{{ element.validFrom | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>

		<!-- Value Column -->
		<ng-container matColumnDef="validTo">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Valid to</th>
			<td mat-cell *matCellDef="let element">{{ element.validTo | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>
